export const buildRegulatoryComplianceFixPrompt = (reason: string | null) =>
  `Repair this template to pass the compliance check. The checker found: ${
    reason ?? 'No specific finding was returned.'
  }`;
